import React, { useState } from "react"
import { Row, Col, Input } from "antd"
import { PoweroffOutlined, SearchOutlined, ShoppingOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"

import "./styles.less"

export const LoginHeader = () => {
  const history = useHistory()
  const [value, setValue] = useState("")

  const onSearch = () => {
    window.open(`https://demeter.vn/product/search?search=${value}`, '_self')
  }

  return (
    <div className="login-header-wrapper max-lg:hidden">
      <Row className="login-header container" align={"middle"} wrap={false}>
        <Col className="logo-wrapper" span={6}>
          <div className="logo">
            <div
              className="logo-container"
              onClick={() => history.push("/")}
            >
              <img src="/assets/png/logo-wide.png" alt="Logo" />
            </div>
          </div>
        </Col>
        
        <Col className="search-wrapper" span={10}>
          <div className="search-container">
            <SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
            <Input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="search-input"
              placeholder="Tìm kiếm..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch()
                }
              }}
              suffix={<span onClick={onSearch} className="search-button">Tìm kiếm</span>}
            />
          </div>
        </Col>
        
        <Col className="actions-wrapper" span={4} offset={2}>
          <div className="login-register-links">
            <PoweroffOutlined />
            <span className="login-link" onClick={() => {
              window.open('/', '_self')
            }}>
              Đăng nhập
            </span>
            <span className="separator">/</span>
            <span className="register-link" onClick={() => {
              window.open('/?mode=register', '_self')
            }}>
              Đăng ký
            </span>
          </div>
        </Col>
        <Col span={2}>
          <div className="cart-icon" onClick={() => window.open("https://demeter.vn/cart", '_self')}>
            <ShoppingOutlined style={{ fontSize: '28px', color: '#333' }} />
            <span className="cart-count">0</span>
          </div>
        </Col>
      </Row>
      <div className="container">
        <div className="header-separator"></div>
      </div>
      <div className="navigation-bar">
        <div className="nav-links">
          <span className="nav-link" onClick={() => window.open('https://demeter.vn/home', '_self')}>Trang Chủ</span>
          <span className="nav-link" onClick={() => window.open('https://demeter.vn/product-list', '_self')}>Sản Phẩm</span>
          <span className="nav-link" onClick={() => window.open('https://demeter.vn/services', '_self')}>Dịch vụ</span>
          <span className="nav-link" onClick={() => window.open('https://demeter.vn/tin-tuc', '_self')}>Tin Tức</span>
          <span className="nav-link" onClick={() => window.open('https://demeter.vn/about-us', '_self')}>Về Demeter</span>
          <span className="nav-link" onClick={() => window.open('https://demeter.vn/contact', '_self')}>Liên hệ</span>
        </div>
      </div>
    </div>
  )
}

export default LoginHeader
